<template>
    <div class="embed_block" @click="markInteracted">
        <b-embed
            type="iframe"
            aspect="16by9"
            :src="blockData.url"
            allowfullscreen
        />
    </div>
</template>

<script>
import CourseBlockMixin from '@/mixins/CourseBlockMixin';
export default {
    name: 'EmbedBlock',
    components: {},
    mixins: [
        CourseBlockMixin,
    ],

    props: {
        id: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            hasInteracted: !!this.blockData.viewed,
        };
    },

    methods:{
        markInteracted() {
            if (this.hasInteracted) {
                return;
            }
            this.hasInteracted = true;
            this.$emit('interacted', this.id);
        },
    },
};
</script>
